import React, { useEffect, useState, useContext } from 'react'
import { collection, query, onSnapshot } from 'firebase/firestore'
import GlobalConfig from '../GlobalConfig'
import ViewIncidents from './ViewIncidents'
import { I18n } from 'galarm-config'
import UserContext from './UserContext'
import { DateTimeUtils } from 'galarm-shared'

const AlertIncidents = ({ alert, filter = 'none' }) => {
  const enterpriseAccountId = window.localStorage.getItem('enterpriseAccountId')
  const { id: alertId, name: alertName, assignees: alertAssignees } = alert

  const [incidents, setIncidents] = useState([])

  const { user } = useContext(UserContext)

  const [showIncidentMenu, setShowIncidentMenu] = useState(false)

  useEffect(() => {
    if (alertAssignees.find(assignee => assignee.id === user.id)) {
      setShowIncidentMenu(true)
    }
    const incidentsQuery = query(
      collection(
        GlobalConfig.firestoreDb,
        'enterpriseAccounts',
        enterpriseAccountId,
        'alerts',
        alertId,
        'incidents'
      )
    )

    // Subscribe to real-time updates
    const unsubscribe = onSnapshot(incidentsQuery, incidentsSnapshot => {
      const updatedIncidents = incidentsSnapshot.docs.map(doc => ({
        id: doc.id,
        ...doc.data()
      }))
      setIncidents(updatedIncidents) // Directly update state with the new array
    })

    return () => unsubscribe() // Cleanup listener on unmount
  }, [alertId, enterpriseAccountId]) // Added dependencies to ensure reactivity

  const columns = [
    {
      label: I18n.t('identifier'),
      key: 'identifier'
    },
    {
      label: I18n.t('timestamp'),
      key: 'timestamp',
      render: incident =>
        DateTimeUtils.getDateTimeWoYearAsString(incident.timestamp)
    },
    {
      label: I18n.t('status'),
      key: 'status'
    }
  ]

  return (
    <ViewIncidents
      showIncidentMenu={showIncidentMenu}
      columns={columns}
      incidents={incidents}
      filter={filter}
      header={I18n.t('incidentsForAlert', { alertName })}
      emptyMessage={I18n.t('noIncidentsForAlert')}
    />
  )
}

export default AlertIncidents
